import React from 'react';
import {css} from '@emotion/core';

const defaultBreakPoint = '600px';
/*
 * Simple usage: n (number of columns, default breakpoint)
 * Advanced usage: n:
 * {
 *   2: '700px',
 *   4: '1200px'
 * }
 */
const Columns = ({n = 2, gap = 0, vAlign = 'stretch', className, children}) => {
  if (typeof(n) !== 'object') n = {[n]: defaultBreakPoint};

  let mqs = Object.entries(n).reduce((s, [colCount, breakpoint]) => {
    return s + `@media (min-width: ${breakpoint}) { grid-template-columns: repeat(${colCount}, 1fr); }`
  }, '');

  let style = css`
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-flow: row;
    grid-auto-rows: auto;
    grid-column-gap: ${gap};
    align-items: ${vAlign};
    ${mqs}
  `
  return (
    <div className={className} css={style}>
      {children}
    </div>
  );
};

export default Columns;